// Plain (non-hook) network calls behind the cached reads, for useOfflineRead (@dowty/offline) to wrap.
//
// Unlike dowtex's src/offline/fetchers.ts, most of this is re-export rather than new mapping code:
// Saufdings' own service layer (services/drinks/DrinkService.ts, services/drinks/EventService.ts)
// already turns grpc-web responses into plain, structured-clone-safe JS - DrinkOption[] and
// DrinkActivitySummary[] with real `Date` fields (see `fromTimestamp` in services/drinkService.ts)
// - rather than raw jspb `.toObject()` output, so there's no extra mapping step to add for those.
//
// The one genuinely new fetcher is the beer pong rules read. It didn't have a promise-returning,
// plain-JS-mapping call anywhere before this - components/Trinkspiele/beerpong/hooks/useBeerpongRules.ts
// used the callback-style `PongerClient` directly - so it's built here from the generated
// `PongerPromiseClient`, the same client-instantiation pattern DrinkService.ts and EventService.ts
// already use (one shared instance per client type, not one per caller).
import { PongerPromiseClient } from '../generated/bpong_grpc_web_pb';
import { RuleProt } from '../generated/bpong_pb';
import GRPC_BACKEND_URL, { GRPC_CLIENT_OPTIONS } from '../grpcConfig';
import type { RuleRow } from '../components/Trinkspiele/beerpong/types';

export { fetchAvailableDrinks as fetchDrinkCatalog, fetchDrinkActivities as fetchRecentActivities } from '../services/drinks/DrinkService';

const pongerClient = new PongerPromiseClient(GRPC_BACKEND_URL, null, GRPC_CLIENT_OPTIONS);

export async function fetchBeerpongRules(): Promise<RuleRow[]> {
  const response = await pongerClient.getRules(new RuleProt());
  return response.getRulesList().map((r) => ({
    rulename: r.getRulename(),
    rule: r.getRule(),
    origin: r.getPlace(),
  }));
}
